/* eslint-disable */
import React, { Component, Button } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactTable from 'react-table';
import history from '../../../../history';

import { SERVER_URL } from '../../../../config';
import ActionButton from '../../../common/ActionButton';
import LoadingSpinner from '../../../common/LoadingSpinner';
import PopupHeader from '../../../common/PopupHeader';
import actions from '../../../../actions';
import JobInfo from './JobInfo';

class Grid extends TabPanel {
    render() {
        return (
            <ReactTable
                pageSize={5}
                data={this.props.data}
                columns={this.props.columns}
                className="modal-table"
                showPageSizeOptions={false}
                noDataText={this.props.noDataText}
            />
        );
    }
}

class JobContainerToolbar extends Component {
    getInvitationText = invitations => {
        if (invitations.fetching) {
            return '';
        }
        if (invitations.error) {
            return 'Retry';
        }
        if (invitations.content) {
            return 'Sent';
        }
        return 'Send Invitations';
    };

    render() {
        const invitationsText = this.getInvitationText(this.props.invitations);
        const invitationsDisabled = !!this.props.invitations.content;
        const loading = this.props.invitations.fetching;
        return (
            <div className="job-container-toolbar">
                {this.props.user.isAgent ? (
                    <ActionButton
                        text={invitationsText}
                        loading={loading}
                        disabled={invitationsDisabled}
                        onAction={this.props.onJobInvitations}
                    />
                ) : (
                    <span />
                )}
            </div>
        );
    }
}

class JobContainer extends Component {
    constructor(props) {
        super(props);
        this.onFetchJob = this.onFetchJob.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.onJobInvitations = this.onJobInvitations.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.onReject = this.onReject.bind(this);
        this.onAccept = this.onAccept.bind(this);
        this.onFetchJob();
    }

    onFetchJob = state => {
        this.props.load(this.props.match.params.id);
    };

    onDismiss = event => history.push('/jobs/list');

    onJobInvitations = () =>
        this.props.jobInvitations(this.props.content.job.id);

    onAccept = data =>
        this.props.accept(this.props.content.job.id, data.original.id);

    onReject = data =>
        this.props.reject(this.props.content.job.id, data.original.id);

    render() {
        if (this.props.fetching || !this.props.content) {
            return (
                <div className="job-details-modal">
                    <LoadingSpinner />
                </div>
            );
        }
        return <div className="job-details-modal">{this.renderContent()}</div>;
    }

    renderContent() {
        const { job } = this.props.content;
        const { bookings } = this.props.content.job;
        const { applications } = this.props.content;
        const { invites } = this.props.content;
        return (
            <div>
                <PopupHeader
                    title={job.reference_number}
                    subtitle={job.summary_for_freelancer}
                    onDismiss={this.onDismiss}
                />
                <JobInfo job={job} applications={applications} />
                <JobContainerToolbar
                    invitations={this.props.invitations}
                    onJobInvitations={this.onJobInvitations}
                    user={this.props.user}
                />
                {this.props.user.isAgent ? (
                    <Tabs>
                        <TabList>
                            <Tab>Bookings</Tab>
                            <Tab>Applications</Tab>
                            <Tab>Invitations</Tab>
                        </TabList>
                        <TabPanel>
                            <Grid
                                columns={this.columns}
                                data={bookings}
                                noDataText="No bookings exist"
                            />
                        </TabPanel>
                        <TabPanel>
                            <Grid
                                columns={this.applicationsColumns}
                                data={applications}
                                noDataText="No applications exist"
                            />
                        </TabPanel>
                        <TabPanel>
                            <Grid
                                columns={this.invitationsColumns}
                                data={invites}
                                noDataText="No invitations exist"
                            />
                        </TabPanel>
                    </Tabs>
                ) : (
                    <Tabs>
                        <TabList>
                            <Tab>Bookings</Tab>
                        </TabList>
                        <TabPanel>
                            <Grid
                                columns={this.columns}
                                data={bookings}
                                noDataText="No bookings exist"
                            />
                        </TabPanel>
                    </Tabs>
                )}
            </div>
        );
    }

    columns = [
        {
            Header: 'Photo',
            accessor: 'freelancer_detail.photo_thumbnail_medium',
            sortable: false,
            headerClassName: 'first-col-fixed',
            className: 'first-col-fixed',
            Cell: row => {
                const freelancerImg = row.original.freelancer_detail
                    .photo_thumbnail_large
                    ? row.value
                    : 'https://static.buzzhire.co/5bdc569/img/freelancer/default_profile.png';
                return (
                    <div>
                        <a className="group-link" href={freelancerImg}>
                            <div
                                style={{
                                    backgroundImage: `url(${freelancerImg})`,
                                    borderRadius: '50%',
                                    backgroundSize: 'cover',
                                    backgroundPosition: '50%',
                                    height: '45px',
                                    width: '45px',
                                }}
                            />
                        </a>
                    </div>
                );
            },
        },
        {
            Header: 'Name',
            accessor: 'freelancer_detail.full_name',
            sortable: false,
            className: 'job-container-modal-cell',
            Cell: row => (
                <div>
                    <a
                        className="group-link"
                        href={`${SERVER_URL}/freelancer/${row.original.freelancer_detail.id}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {row.value}
                    </a>
                </div>
            ),
        },
        {
            Header: 'Ref',
            accessor: 'reference_number',
            id: 'reference_number',
            className: 'job-container-modal-cell',
            maxWidth: 100,
        },
        {
            Header: 'Pay per hour',
            accessor: 'freelancer_pay_per_hour',
            id: 'freelancer_pay_per_hour',
            className: 'job-container-modal-cell',
            maxWidth: 120,
        },
        {
            Header: 'Status',
            accessor: 'status',
            id: 'Status',
            className: 'job-container-modal-cell',
        },
    ];

    applicationsColumns = [
        {
            Header: '',
            accessor: 'freelancer_detail.photo_thumbnail_medium',
            sortable: false,
            maxWidth: 72,
            Cell: row => {
                const freelancerImg = row.original.freelancer_detail
                    .photo_thumbnail_large
                    ? row.value
                    : 'https://static.buzzhire.co/5bdc569/img/freelancer/default_profile.png';
                return (
                    <div>
                        <a className="group-link" href={freelancerImg}>
                            <img
                                className="rounded-image"
                                src={freelancerImg}
                                height="40"
                                width="60"
                            />
                        </a>
                    </div>
                );
            },
        },
        {
            Header: 'Name',
            accessor: 'freelancer_detail.full_name',
            sortable: false,
            className: 'job-container-modal-cell',
            Cell: row => (
                <div>
                    <a
                        className="group-link"
                        href={`${SERVER_URL}/freelancer/${row.original.freelancer_detail.id}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {row.value}
                    </a>
                </div>
            ),
        },
        {
            Header: 'Rating',
            accessor: 'freelancer_detail.average_score',
            id: 'Rating',
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Invited',
            accessor: 'Invited',
            id: 'Invited',
            Cell: row => moment(row.value).format('DD/MM/YY hh:mm A'),
            minWidth: 150,
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Score',
            accessor: 'matching_coefficients.rating',
            Cell: row => new Number(row.value).toPrecision(3),
            id: 'Score',
            className: 'job-container-modal-cell',
        },

        {
            /*
        {
            Header: '',
            className: 'job-container-modal-cell',
            accessor: 'status',
            minWidth: 120,
            Cell: data => {
                const onAccept = event => {
                    this.onAccept(data);
                };
                const onReject = event => {
                    this.onReject(data);
                };
                return (
                    <div>
                        <ActionButton text="Accept" onAction={onAccept} compact={true} />
                        <ActionButton text="Reject" onAction={onReject} compact={true} />
                    </div>
                );
            }
        }
        */
        },
    ];

    invitationsColumns = [
        {
            Header: '',
            accessor: 'freelancer_detail.photo_thumbnail_medium',
            sortable: false,
            maxWidth: 72,
            Cell: row => {
                const freelancerImg = row.original.freelancer_detail
                    .photo_thumbnail_large
                    ? row.value
                    : 'https://static.buzzhire.co/5bdc569/img/freelancer/default_profile.png';
                return (
                    <div>
                        <a className="group-link" href={freelancerImg}>
                            <img
                                className="rounded-image"
                                src={freelancerImg}
                                height="40"
                                width="60"
                            />
                        </a>
                    </div>
                );
            },
        },
        {
            Header: 'Name',
            accessor: 'freelancer_detail.full_name',
            sortable: false,
            className: 'job-container-modal-cell',
            Cell: row => (
                <div>
                    <a
                        className="group-link"
                        href={`${SERVER_URL}/freelancer/${row.original.freelancer_detail.id}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {row.value}
                    </a>
                </div>
            ),
        },
        {
            Header: 'Rating',
            accessor: 'freelancer_detail.average_score',
            id: 'Rating',
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Invited',
            accessor: 'Invited',
            id: 'Invited',
            Cell: row => moment(row.value).format('DD/MM/YY hh:mm A'),
            minWidth: 150,
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Score',
            accessor: 'matching_coefficients.rating',
            Cell: row => new Number(row.value).toPrecision(3),
            id: 'Score',
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Status',
            accessor: 'status',
            id: 'Status',
            className: 'job-container-modal-cell',
        },
    ];
}

const mapStateToProps = (state, ownProps) => ({
    ...state.job,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: (state, instance) => dispatch(actions.loadJob(state)),
    jobInvitations: jobId => dispatch(actions.jobInvitations(jobId)),
    accept: (jobId, invitationId) =>
        dispatch(actions.acceptInvitation({ jobId, invitationId })),
    reject: (jobId, invitationId) =>
        dispatch(actions.rejectInvitation({ jobId, invitationId })),
});
export default connect(mapStateToProps, mapDispatchToProps)(JobContainer);
